import  '../../../node_modules/font-awesome/css/font-awesome.css'


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/styles/fawesome/index.ts